import * as React from 'react';

import { GoogleMap } from 'sletat-ui-components/lib/GoogleMap';


export interface MapProps {
    latitude: number;
    longitude: number;
    isAdaptive: boolean;
    containerWidth?: number;
    containerHeight?: number;
}

export class Map extends React.Component<MapProps, {}> {
    render(): JSX.Element | null {
        if (this.props.isAdaptive) {
            return (
                <GoogleMap
                    marker={{ lat: this.props.latitude, lng: this.props.longitude }}
                    width="100%"
                    height="100%"
                />
            );
        }

        return (
            <GoogleMap
                marker={{ lat: this.props.latitude, lng: this.props.longitude }}
                width={this.props.containerWidth}
                height={this.props.containerHeight}
            />
        );
    }
}
